export default __webpack_public_path__ + "static/media/health.5fabeea4.jpg";